import { UserActivationActionType } from 'components/userActivationControl';

export enum UserType {
  Staff = 'Staff',
  Student = 'Student',
  Administrator = 'Administrator',
}

export const USER_ACTIVATION_STATUS_OPTIONS = [
  { label: 'Active', value: UserActivationActionType.Activate },
  { label: 'Disabled', value: UserActivationActionType.Deactivate },
] as const;
